// extracted by css-extract-rspack-plugin
export default {"title":"title-XxP3z3","root":"root-x2nRd7","dropdown":"dropdown-DdlHoo","label":"label-vTEn48","buttons":"buttons-f7xgT2","button":"button-uE0rVR","wrapper":"wrapper-C1djRh"};